import React from "react";
import ProtectedLayout from "./ProtectedLayout";
import NativeTabLayout from "../components/Native/NativeTabLayout";
import { NotificationsProvider } from "../components/Notifications/NotificationsProvider";
import { isNative } from "../lib/platform";

/**
 * Chooses the app shell per platform: bottom-tab navigation in the native
 * (Capacitor) app, the existing sidebar/drawer layout on web. Both render the
 * same routed pages through the same provider stack.
 */
const AppShell: React.FC = () => {
  return (
    <NotificationsProvider>
      {isNative() && <NativeTabLayout />}
      {!isNative() && <ProtectedLayout />}
    </NotificationsProvider>
  );
};

export default AppShell;
